import { Button } from "@blueprintjs/core";
import { useMount } from "ahooks";
import { t } from "i18next";
import React from "react";
import { useHistory } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import styled from "styled-components";

import { FullPageLoader } from "./components";
import { useAuth, useDialog } from "./contexts";
import { useTl } from "./hooks";
import { ETLCodes } from "./locales";

export interface PublicAppRouterProps {}
const DisconnectButtonContainer = styled.div`
  float: right;
`;
export enum EPublicRoutes {
  logout = "/logout",
  myappeals = "/appeals",
  appeal = "/appeals",
  resetPassword = "/resetPassword",
}
const LogoutPage = React.lazy(() => import("./pages/public/login/LogoutPage"));

const MyAppealListPage = React.lazy(
  () => import("./pages/public/appeal/MyAppealListPage")
);

const PublicAppealFormPage = React.lazy(
  () => import("./pages/public/appeal/PublicAppealFormPage")
);
const ResetPasswordPage = React.lazy(
  () => import("./pages/public/login/ResetPassword")
);

export const PublicAppRouter: React.FC<PublicAppRouterProps> = () => {
  const history = useHistory();
  const { t } = useTl();
  const { logout } = useAuth();
  const { showDialog } = useDialog();
  useMount(() => {
    history.listen((location, action) => {});
  });

  const logoutClick = React.useCallback(async () => {
    showDialog({
      message: t(ETLCodes.LogoutConfirmationMessage),
      title: t(ETLCodes.RouteConfirmDialogTitle),
      onConfirmed: () => {
        logout();
      },
    });
  }, [logout, showDialog, t]);

  return (
    <div style={{ width: "100%" }}>
      <DisconnectButtonContainer>
        <Button
          icon="log-out"
          text={t(ETLCodes.Logout)}
          onClick={logoutClick}
          intent="danger"
        />
      </DisconnectButtonContainer>
      <React.Suspense fallback={<FullPageLoader fullHeight={false} />}>
        <Switch>
          <Route path={`${EPublicRoutes.logout}`} component={LogoutPage} />
          <Route
            path={`${EPublicRoutes.resetPassword}`}
            component={ResetPasswordPage}
          />

          <Route
            path={`${EPublicRoutes.myappeals}`}
            component={MyAppealListPage}
            exact={true}
          />
          <Route
            path={`${EPublicRoutes.appeal}/:id/:step?`}
            component={PublicAppealFormPage}
          />

          <Redirect to={EPublicRoutes.myappeals} />
        </Switch>
      </React.Suspense>
    </div>
  );
};
